import { render, staticRenderFns } from "./SpecimenList.vue?vue&type=template&id=fb703170&scoped=true"
import script from "./SpecimenList.vue?vue&type=script&lang=js"
export * from "./SpecimenList.vue?vue&type=script&lang=js"
import style0 from "./SpecimenList.vue?vue&type=style&index=0&id=fb703170&prod&lang=scss&scoped=true"
import style1 from "./SpecimenList.vue?vue&type=style&index=1&id=fb703170&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb703170",
  null
  
)

export default component.exports